import dayjs from "dayjs"
import { useStore } from "~/stores"

export const useCampaign = () => {
  const { user } = useStore()
  const config = useRuntimeConfig()
  const isProduction = config.public.APP_ENV === "production"

  /**
   * 母の日＆父の日キャンペーン期間中かどうか
   */
  const isMothersAndFathersCampaign = () => {
    if (isProduction) {
      // 本番確認用にtentialドメインでログインしている場合はtrueで返す
      if (user.email && user.email.includes("@tential.jp")) {
        return true
      }
      return dayjs().isBetween("2025-04-25 10:00", "2025-06-16 11:59")
    }
    return true
  }

  /**
   * 父の日表示にするかどうか
   * テスト環境は確認できるように、urlに`?f=1`がついていれば父の日表示にする
   */
  const isFathersDay = () => {
    if (isProduction) {
      return dayjs().isAfter("2025-05-23 10:00")
    }
    const route = useRoute()
    const fathersDay = route.query.f
    return !!fathersDay
  }

  return {
    isMothersAndFathersCampaign,
    isFathersDay,
  }
}
